import React from "react";
import cancel from "../../Assets/cancel.png";

const MovieTitleCard = (props) => {
  // console.log(props);
  const display = props.display;

  const handleCancel = (e) => {
    e.preventDefault();
    props.handleCancel(props);
  };

  return (
    <div>
      {display === "display" ? (
        <div className="movie-title-card">{props.title}</div>
      ) : (
        <div className="movie-title-card-cancel">
          {props.title}
          <img src={cancel} alt="cancel item" onClick={handleCancel} />
        </div>
      )}
    </div>
  );
};

export default MovieTitleCard;
